import { z } from 'zod'

import { DateZod } from '../../common'

export const UserTokensZod = z.record(
  z.string(),
  z.object({
    device: z.string().optional(),
    timestamp: DateZod,
  })
)
